import React from 'react'
import { getSession } from '../../utils/api'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import { complianceMerchantEnvironment, RouteConstants } from '../../utils/constants'

export const CompliancePage = (props) => {
  const session = getSession()
  const authToken = session ? session.accessToken : null
  const environment = process.env.COMPLIANCE_ENVIRONMENT
    ? process.env.COMPLIANCE_ENVIRONMENT.toUpperCase()
    : complianceMerchantEnvironment[props.facility.environment]

  return (
    <SingleSpaParcel
      {...props}
      basename={RouteConstants.COMPLIANCE().BASE}
      authToken={authToken}
      origin='blu'
      merchantId={props.merchantId}
      services={{
        permissionService: {
          getValidationRequestData: () => {
            if (!props.facility) return {}

            return {
              externalId: props.facility.facLicense,
              xUserKey: props.facility.userApiKey,
              environment,
            }
          },
        },
      }}
      config={mfeConfigs.LOAD_COMPLIANCE_PAGE}
    />
  )
}


// WEBPACK FOOTER //
// ./src/components/MfeParcels/CompliancePage.js